import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[validationMessage]'
})
export class ValidationMessageDirective {
  @HostBinding('style.display') display = 'none';

  constructor(private el: ElementRef) { }

  show(message?: string) {
    const e: Element = this.el.nativeElement;
    e.textContent = message;

    this.display = 'block';
  }

  hide() {
    this.display = 'none';
  }
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/forms/validation-message.directive.ts